import ministryService from "../../../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    loadingUpdate : false ,
    TransactionType: {},
    TransactionActions :{},
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    loadingUpdate(state) {
      return state.loadingUpdate;
    },
    TransactionType(state) {
      return state.TransactionType;
    },
    TransactionActions(state) {
      return state.TransactionActions;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLoadingUpdate(state, payload) {
      state.loadingUpdate = payload;
    },
    setTransactionType(state, payload) {
      state.TransactionType = payload;
    },
    setTransactionActions(state, payload) {
      state.TransactionActions = payload;
    },
  },
  actions: {
    async fetchTransactionTypeById({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchTransactionTypeById(params);
        commit("setTransactionType", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchTransactionActionsById({ commit }, params) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchTransactionActionsById(params);
        commit("setTransactionActions", data.data);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    
    async updateTransactionActionsById({ commit }, params) {
      commit("setLoadingUpdate", true);
      try {
        const data = await ministryService.updateTransactionActionsById(params);
        commit("setTransactionActions", data.data);
      } catch (err) {
      } finally {
        commit("setLoadingUpdate", false);
      }
    },
    async updateTransactionType({ commit, dispatch }, payload) {
      commit("setLoadingUpdate", true);
      
      try {
        const res = await ministryService.updateTransactionType(payload);
        if (hasError(res.status)) {
          throw res.status;
        }
        
        
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoadingUpdate", false);
      }
    },

    handleResponse({ commit, dispatch }, res) {
      if(res.hasOwnProperty('status'))
      {
        if (res.status > 399 && res.status <= 500) {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "حدث خطأ أثناء تنفيذ العملية",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
          throw res.status;
        } else {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت العملية بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      }
    },
  },
};
